// extracted by extract-css-chunks-webpack-plugin
module.exports = {"arabicSpaceAfter":"formatted-date__arabicSpaceAfter--2FSN7"};